// Layout.jsx
import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(true);
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 640;
      setIsMobile(mobile);
      if (mobile) {
        setIsDropdownOpen(false);
      } else {
        setIsDropdownOpen(true);
      }
    };

    handleResize(); // Initialize on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setIsOpen(isDropdownOpen);
  }, [isDropdownOpen]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobile && isDropdownOpen && !event.target.closest('.insideSidbar') && !event.target.closest('.navbar-toggle')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobile, isDropdownOpen]);



  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900 overflow-hidden">
      {/* Sidebar */}
      <div className={`insideSidbar fixed inset-y-0 left-0 z-50 transition-transform duration-300 transform ${isMobile && !isOpen ? '-translate-x-full' : 'translate-x-0'} ${!isMobile && !isOpen ? 'w-12' : isMobile ? 'w-64' : 'w-64'}`}>
        <Sidebar isOpen={isOpen} />
      </div>

      {/* Backdrop for mobile */}
      {isMobile && isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 sm:hidden backdrop-blur-sm transition-opacity"
          onClick={() => setIsDropdownOpen(false)}
        ></div>
      )}

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Navbar */}
        <Navbar isDropdownOpen={isDropdownOpen} setIsDropdownOpen={setIsDropdownOpen} />

        {/* Content */}
        <main className={`flex-1 overflow-y-auto mt-16 transition-all duration-300 ease-in-out dark:bg-gray-800 dark:text-gray-50 ${isMobile ? 'ml-0' : (!isOpen ? 'ml-12' : 'ml-64')}`}>
          <div className="p-3 md:p-6 min-h-full">
            <div className="bg-white dark:bg-gray-900 shadow-sm rounded-xl p-4 md:p-6">
              {children}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Layout;
